import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Pagination
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders, setFilters } from "../../../Reducer/Order/orderListslice";
import FiltersBar from "./FiltersBar";
import OrdersTable from "./OrdersTable";
import ActionMenu from "./ActionMenu";
import ViewActivityDialog from "./ViewActivityDialog";

const OrdersManagement = () => {
  const dispatch = useDispatch();
  const { orders, loading, error, filters, totalPages, totalOrders } =
    useSelector((state) => state.orderList);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [activityDialogOpen, setActivityDialogOpen] = useState(false);

  // Fetch orders whenever filters change
  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch, filters]);

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    dispatch(setFilters({ [key]: value, page: 1 })); // reset to page 1
  };

  // Handle pagination change
  const handlePageChange = (_, page) => {
    dispatch(setFilters({ page }));
  };

  // Menu actions
  const handleMenuOpen = (event, order) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrder(order);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedOrder(null);
  };

  const handleAction = (action) => {
    if (action === "View Activity") {
      setActivityDialogOpen(true);
      setAnchorEl(null);
      return;
    }
    alert(`${action} clicked for order ID: ${selectedOrder?.id}`);
    handleMenuClose();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          {/* Header */}
          <Box mb={2}>
            <Typography variant="h5" fontWeight={700}>
              Orders Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage all orders — Total: {totalOrders}
            </Typography>
          </Box>

          {/* Filters */}
          <FiltersBar filters={filters} onFilterChange={handleFilterChange} />

          {/* Table */}
          {loading ? (
            <Box display="flex" justifyContent="center" my={4}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error" align="center">
              {error}
            </Typography>
          ) : (
            <OrdersTable
              orders={orders}
              onMenuOpen={handleMenuOpen}
              currentPage={filters.page}
              limit={filters.limit}
            />
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <Box display="flex" justifyContent="center" mt={3}>
              <Pagination
                count={totalPages}
                page={filters.page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}

          {/* Action Menu */}
          <ActionMenu
            anchorEl={anchorEl}
            onClose={handleMenuClose}
            onAction={handleAction}
            selectedOrder={selectedOrder}
          />

          <ViewActivityDialog
            open={activityDialogOpen}
            onClose={() => {
              setActivityDialogOpen(false);
              setSelectedOrder(null);
            }}
            order={selectedOrder}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default OrdersManagement;
